//@flow
import * as React from 'react';
import moment from 'moment-timezone';
import SingleSlotSelectorWithBreaks from 'common/entity/components/slot/SingleSlotSelectorWithBreaks';
import { SlotType } from 'common/enums/SlotEnum';
import DayShiftSlotsSelector from 'common/entity/components/dayShift/DayShiftSlotsSelector';
import slotsSelectorFactory from 'common/entity/components/slot/SlotsSelectorFactory';
import ShiftLocationsInput from 'common/entity/components/dayShift/ShiftLocationsInput';
import { DateInputFormats } from 'common/utils/DateTimeUtils';

export const EverydaySlotsSelector = ({
    timeSlots,
    theme,
    createInitialSlots,
    onSlotChange,
    t,
    onAddBreakClick,
    showBreaksDialog,
    ...others
}) => {
    // For everyday, show the first day's (monday) slots, every day should be same
    let firstDay;
    if (timeSlots.length) {
        [firstDay] = timeSlots;
    } else {
        [firstDay] = createInitialSlots();
    }
    const { slot, breaks } = firstDay;
    const start = moment(slot.start, DateInputFormats.HOUR24_SHORT);
    const end = moment(slot.end, DateInputFormats.HOUR24_SHORT);
    const { startLocationPlaceholder, endLocationPlaceholder } = others;
    return (
        <div className={theme.slotOptionsWrap}>
            <SingleSlotSelectorWithBreaks
                {...others}
                breaks={breaks}
                t={t}
                theme={theme}
                start={start}
                end={end}
                slotFor={SlotType.EVERYDAY}
                onChange={onSlotChange}
                onAddBreakClick={onAddBreakClick}
                dayShift={firstDay}
                showBreaksDialog={showBreaksDialog}
            />
            <ShiftLocationsInput
                onSlotChange={onSlotChange}
                slotType={SlotType.EVERYDAY}
                startLocationPlaceholder={startLocationPlaceholder}
                endLocationPlaceholder={endLocationPlaceholder}
                t={t}
                timeSlot={firstDay}
                theme={theme}
            />
        </div>
    );
};

const WorkingDaysSelector = slotsSelectorFactory({
    MultiDayWeekSlotsSelector: DayShiftSlotsSelector,
    EverydaySlotsSelector
});

export { WorkingDaysSelector };
export default WorkingDaysSelector;
